// extracted by mini-css-extract-plugin
module.exports = {"legendPriceRoot":"Vn_FgV9l","priceContainer":"wqaBOg8g"};